// Types for Brightcove Data Collection API v2
// https://apis.support.brightcove.com/data-collection/getting-started/overview-data-collection-api-v2.html

export enum BrightcoveEvents {
  player_load = 'player_load',
  video_impression = 'video_impression',
  catalog_request = 'catalog_request',
  catalog_response = 'catalog_response',
  play_request = 'play_request',
  video_view = 'video_view',
  video_engagement = 'video_engagement',
  ad_mode_begin = 'ad_mode_begin',
  ad_mode_complete = 'ad_mode_complete',
  error = 'error',
}

export interface BrightcoveEventData {
  // Required fields for all events
  session?: string;
  event?: BrightcoveEvents;
  domain?: string; // Always "videocloud"
  time?: number; // Timestamp in epoch milliseconds
  timestamp?: number;

  // Traffic analysis
  destination?: string; // URI where video is being watched
  source?: string; // Referrer URI

  // Video metadata
  video?: string; // video ID
  video_name?: string;
  video_duration?: number;
  account?: string;
  player?: string;
  player_name?: string;

  // Session metadata
  device_type?: string;
  device_os?: string;
  device_os_version?: string;
  device_manufacturer?: string;
  browser_type?: string;
  user_agent?: string;
  user?: string; // Unique user identifier

  // Platform information
  platform_version?: string;
  player_version?: string;

  // Geographic data
  country?: string;
  region?: string;
  city?: string;

  // Engagement specific fields
  range?: string; // "start,end" in seconds
  video_seconds_viewed?: number;

  // QoE (Quality of Experience) fields
  rendition_url?: string;
  rendition_indicated_bps?: number;
  rendition_mime_type?: string;
  rendition_height?: number;
  rendition_width?: number;
  rebuffering_seconds?: number;
  rebuffering_count?: number;
  forward_buffer_seconds?: number;
  measured_bps?: number;
  player_width?: number;
  player_height?: number;
  dropped_frames?: number;

  // Latency measurements for video_view
  load_time_ms?: number;
  start_time_ms?: number;

  // Error specific fields
  error_code?: string;

  // Catalog specific fields
  catalog_url?: string;
  response_time_ms?: number;
}

export interface BrightcoveAnalyticsConfig {
  accountId: string;
  playerId?: string;
  playerName?: string;
  userId?: string;
  sessionId?: string;
  baseUrl?: string;
  enableQoE?: boolean;
  engagementUpdateInterval?: number; // seconds
}

export interface BrightcoveAnalyticsPlugin {
  config: BrightcoveAnalyticsConfig;
  trackData: any;
  playableItem: any;
}

export interface EngagementRange {
  start: number;
  end: number;
  watchedSeconds: number;
}

export interface SessionData {
  sessionId: string;
  playbackStarted: boolean;
  lastEngagementTime: number;
  lastVideoPosition: number; // Track last video position in seconds
  totalWatched: number;
  ranges: EngagementRange[];
  currentRendition?: {
    url: string;
    bps: number;
    mimeType: string;
    width: number;
    height: number;
  };
  qoeData?: {
    rebufferingSeconds: number;
    rebufferingCount: number;
    droppedFrames: number;
  };
}
